import type { ReactNode } from 'react';

export const symbol_flight_land: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M150-120q-13 0-21.5-8.5T120-150q0-13 8.5-21.5T150-180h660q13 0 21.5 8.5T840-150q0 13-8.5 21.5T810-120H150Zm603-209L164-498q-20-5-32-21t-12-36v-189q0-17 13.5-27t29.5-5l19 5q8 2 14 8t9 14l44 127 164 47-30-294q-2-22 15-36t38-8l17 5q10 3 17.5 9.5T481-882l125 363 183 52q22 7 36.5 25.5T840-398q0 32-25.5 56T753-329Z"
		/>
	</svg>
);
